import { watch } from 'vue';
import type { AsyncDataOptions } from '#app';

export default async function useRequiredAsyncData<T>(
  key: string,
  handler: () => Promise<T>,
  options?: AsyncDataOptions<T>,
) {
  const result = await useLazyAsyncData<T>(key, handler, options);

  if (import.meta.server) {
    if (result.error.value) throw result.error.value;
  } else {
    watch(
      result.error,
      (error) => {
        if (error) showError(error);
      },
      { immediate: true },
    );
  }

  return result;
}
